import { BehaviorSubject } from "rxjs";
import { FormControl } from "@angular/forms";

export enum FiltersTypeEnum {
  TextSearch = 1,
  ComboBox = 2,
  DateFilter = 3,
  RangeDateFilter = 4,
  RangeDateSimpleFilter = 5,
  ComboTextSearch = 6,
  // The generic tag filter used in photos and news components.
  TagsFilter = 7,
}

/**
 * An interface for set the router params interceptor of FilterRouterReference.
 *
 * @export
 * @interface IFilterRouterParams
 */
export interface IFilterRouterParams {
  // The name of query to be intercepted.
  intercept_name?: string;
  // Only on init property for set the first time only.
  only_on_init?: boolean;
  // The delay time for allow combos or filter to be stabilized when they're part of a largue stream.
  delay_time?: number;
}

export interface IFilterTextComponent extends IFilterRouterParams {
  type: FiltersTypeEnum.TextSearch;
  id: string;
  defaultTextValue: string;
  text_subject: BehaviorSubject<string>;
}

/**
 * Interface of combo filter.
 *
 * @export
 * @interface IFilterComboComponent
 */
export interface IFilterComboComponent extends IFilterRouterParams {
  type: FiltersTypeEnum.ComboBox;
  name_filter: string;
  options_subject: BehaviorSubject<Array<any>>;
  option_name_property: string;
  options_selected_subject: BehaviorSubject<any>;
  hide_callback_change?:BehaviorSubject<(value) => boolean>;
  initial_state?: boolean;
  hideFilter?: boolean;
  hideDataCallback?: (element: any) => boolean;
  id: string;
  // Allow select multiple options.
  selectMultiple?:boolean;
  // Allow text search.
  withTextSearch?:boolean;
  // Allow show by group.
  showByGroup?:boolean;
  // The group label property name.
  groupPropertyName?:string;
  // The group data property name.
  groupDataPropertyName?:string;
  // A custom render function.
  renderFunc?:(value: any) => HTMLElement;
  // The render function selected.
  renderFuncSelected?: (value: any) => string | HTMLElement;
  // The render function group separator.
  renderFuncGroupSeparator?: (value: any) => string | HTMLElement;
}



export interface IFilterComboTextSearchComponent extends IFilterComboComponent {
  type: any;
  funcToFilter?: (opt: string[], value: string) => string[];
  groupKey: string;
  groupProperty: string;
}
export interface IFilterDateComponent extends IFilterRouterParams {
  type: FiltersTypeEnum.DateFilter;
  placeholder: string;
  dateFormControl: FormControl;
  date_subject: BehaviorSubject<Date>;
  date_format?: string;
  // The min date allowed.
  min_date?: Date;
  // The max date allowed.
  max_date?: Date;
  id: string;
}
export interface IFilterRangeDateComponent {
  type: FiltersTypeEnum.DateFilter;
  placeholder: string;
  dateFormControl: FormControl;
  date_subject: BehaviorSubject<Date>;
  date_format?: string;
  hideFilter?: boolean;
  id: string;
}
export interface IFilterRangeSimpleComponent extends IFilterRouterParams {
  hideFilter?: boolean;
  type: FiltersTypeEnum.RangeDateSimpleFilter;
  date_from: IFilterDateComponent;
  date_to: IFilterDateComponent;
}
export type ITypeFilter =
  IFilterComboTextSearchComponent |
  IFilterRangeSimpleComponent |
  IFilterComboComponent |
  IFilterDateComponent |
  IFilterTextComponent |
  IFilterRangeDateComponent |
  { class: string, data: FiltersComponentInterface };
export type FiltersComponentInterface = Array<{
  options: ITypeFilter;
}>;
